import { render, staticRenderFns } from "./TabbarHome.vue?vue&type=template&id=795f3c29&scoped=true&"
import script from "./TabbarHome.vue?vue&type=script&lang=js&"
export * from "./TabbarHome.vue?vue&type=script&lang=js&"
import style0 from "./TabbarHome.vue?vue&type=style&index=0&id=795f3c29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795f3c29",
  null
  
)

export default component.exports